import React, { createContext, useContext } from 'react'
import { useRelatorioDeTrocaService } from './useRelatorioDeTrocaService'
import { useExcelGenerator } from '../../../../hooks/useExcelGenerator'
import { usePdfGeneratorNew } from '../../../../hooks/usePdfGenerator'

const RelatorioDeTrocaContext = createContext({})

export const RelatorioDeTrocaProvider = ({ children }) => {
  const relatorioDeTrocaService = useRelatorioDeTrocaService()
  const { generateExcel, loading: excelLoading } = useExcelGenerator()
  const { generatePDF, loading: pdfLoading } = usePdfGeneratorNew()

  // Cabeçalhos para exportação
  const excelHeader = [
    'Data',
    'Fornecedor',
    'Nota Fiscal',
    'Item',
    'Código do Produto',
    'Quantidade Pedido',
    'Quantidade Troca',
    'Pedido Innovation',
    'Pedido SPOT',
  ]

  // Função para exportar uma única troca para Excel
  const exportarTrocaExcel = (troca) => {
    const dataItem = [
      {
        data: new Date(troca.data_solicitacao).toLocaleDateString('pt-BR'),
        fornecedor: troca.nome_fornecedor,
        nota_fiscal: troca.nota_fiscal,
        item: troca.descricao_produto,
        codigo: troca.codigo_produto,
        quantidade_pedido: troca.qtd_produto,
        quantidade_troca: troca.qtd_troca,
        pedido_innovation: troca.numero_pedido,
        pedido_spot: troca.pedido_spot || '-',
      },
    ]

    generateExcel(excelHeader, dataItem, `Troca-${troca.nota_fiscal}-${troca.numero_pedido}`)
  }

  // Função para exportar todas as trocas para Excel
  const exportarTodasTrocasExcel = () => {
    const dataItems = relatorioDeTrocaService.trocas.map((troca) => ({
      data: new Date(troca.data_solicitacao).toLocaleDateString('pt-BR'),
      fornecedor: troca.nome_fornecedor,
      nota_fiscal: troca.nota_fiscal,
      item: troca.descricao_produto,
      codigo: troca.codigo_produto,
      quantidade_pedido: troca.qtd_produto,
      quantidade_troca: troca.qtd_troca,
      pedido_innovation: troca.numero_pedido,
      pedido_spot: troca.pedido_spot || '-',
    }))

    generateExcel(excelHeader, dataItems, 'Relatório-Trocas')
  }

  // Função para exportar uma única troca para PDF
  const exportarTrocaPDF = (troca) => {
    const pdfData = [
      [
        new Date(troca.data_solicitacao).toLocaleDateString('pt-BR'),
        troca.nome_fornecedor,
        troca.nota_fiscal,
        troca.descricao_produto,
        troca.codigo_produto,
        troca.qtd_produto,
        troca.qtd_troca,
        troca.numero_pedido,
        troca.pedido_spot || '-',
      ],
    ]

    generatePDF(excelHeader, pdfData, `Troca-${troca.nota_fiscal}-${troca.numero_pedido}`)
  }

  // Função para exportar todas as trocas para PDF
  const exportarTodasTrocasPDF = () => {
    const pdfData = relatorioDeTrocaService.trocas.map((troca) => [
      new Date(troca.data_solicitacao).toLocaleDateString('pt-BR'),
      troca.nome_fornecedor,
      troca.nota_fiscal,
      troca.descricao_produto,
      troca.codigo_produto,
      troca.qtd_produto,
      troca.qtd_troca,
      troca.numero_pedido,
      troca.pedido_spot || '-',
    ])

    generatePDF(excelHeader, pdfData, 'Relatório-Trocas')
  }

  const contextValue = {
    ...relatorioDeTrocaService,
    exportarTrocaExcel,
    exportarTodasTrocasExcel,
    exportarTrocaPDF,
    exportarTodasTrocasPDF,
    excelLoading,
    pdfLoading,
  }

  return <RelatorioDeTrocaContext.Provider value={contextValue}>{children}</RelatorioDeTrocaContext.Provider>
}

export const useRelatorioDeTroca = () => useContext(RelatorioDeTrocaContext)
